import { render, staticRenderFns } from "./ChannelOptions.vue?vue&type=template&id=fc6664ee&scoped=true&"
import script from "./ChannelOptions.vue?vue&type=script&lang=js&"
export * from "./ChannelOptions.vue?vue&type=script&lang=js&"
import style0 from "./ChannelOptions.vue?vue&type=style&index=0&id=fc6664ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6664ee",
  null
  
)

export default component.exports